import { RacingStore } from "../../../data/store";
var RacingCombinedViewData = /** @class */ (function () {
    function RacingCombinedViewData(provider, nextRacesCount, appNavigation) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };
        this.racingStore.nextRacesCount = nextRacesCount;
        this.racingStore.appNavigation = appNavigation;
    }
    RacingCombinedViewData.prototype.setParams = function (regionId, branchId) {
        this.racingStore.setParams(regionId, branchId);
    };
    RacingCombinedViewData.prototype.deactivate = function () {
        this.racingStore.clear();
    };
    return RacingCombinedViewData;
}());
export { RacingCombinedViewData };
//# sourceMappingURL=RacingCombinedViewData.js.map